export * from './user-detail.component';
export * from './user-detail.service';
export * from './user-update-status.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-detail/index.ts